module.exports = __webpack_public_path__ + "img/task-6.f14ce6c2.png";